<div class="fixed scrollable-container">
<div class="container">
 

<div  *ngIf="!loading; else load" class="row">
	<div *ngIf="stat" class="col-12">
<!--
<div class="row">
<div class="col-12">
		<div class="topPanel">
			<div><div  (click)="refresh()" class="item"><nb-icon [icon]="'refresh-outline'" pack="eva"></nb-icon></div></div>
		</div>
</div>

</div>
-->

<div class="row">
<div class="col-12">
		<h5 class="mainTitle">{{stat.title}}</h5>
</div>

</div>
 		

		<div class="row">
			<div class="col-12 col-sm-6 col-md-6 col-md-6 col-lg-3 statColumn">

			<div class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Візити</div>
				<div  class="statItemBigMetric">{{stat.visits.all}}</div>
				 
			</div> 
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div  class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Унікальні Візити</div>
				<div  class="statItemBigMetric">{{stat.uniqueVisits.all}}</div>
				 
			   </div>

			</div>

			 <div class="col-12  col-md-12 col-lg-6 statColumn">

 
			</div>
		</div> 

<div class="row">
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Перегляд</div>
				<div  class="statItemBigMetric">{{stat.visits.live + stat.visits.vod}}</div>
				  

				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.visits.live}}</span></div>
				<div class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.visits.vod}}</span></div>
		
				 
			</div> 
		</div>
			<div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

			<div  class="statItem statItemSquare statItemRectMin">
				<div class="statItemHead">Унікальні перегляди</div>
				<div  class="statItemBigMetric">{{stat.uniqueVisits.live + stat.uniqueVisits.vod}}</div>
				 
				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.uniqueVisits.live}}</span></div>
				<div class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.uniqueVisits.vod}}</span></div>
		
				 
			   </div>

			</div>

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

	<div  class="statItem statItemSquare">
				<div class="statItemHead">Середній час</div>
				<div  class="statItemBigMetric">{{stat.watchTime || 0}}</div>
				<div  class="bottomMetrics"><span class="label">Ефір</span> <span class="num">{{stat.liveTime || 0}} хв.</span></div>
				<div   class="bottomMetrics"><span class="label">Запис</span> <span class="num">{{stat.vodTime || 0}} хв.</span></div>		 	

		</div>
 
			</div>
 
			

			 <div class="col-12 col-sm-6  col-md-6 col-lg-3 statColumn">

<div class="statItem statItemSquare  ">
				<div class="statItemHead">Актив. ключі</div>
				<div  class="statItemBigMetric">{{stat.keysUsedCount}}</div>
				
			<div style="width:auto;margin: auto;margin-top: -2px;" class="bottomMetrics"><span class="label">з</span> <span  style="margin-left:5px" class="num">{{stat.keysCount}}</span></div>
				<div style="margin-top:12px"  class="bottomMetrics">  <button [disabled]="!stat?.keysCount" (click)="openKeysModal()" nbButton fullWidth outline status="primary">Детальніше</button></div>
			</div>
			 

			</div>




		</div> 



		<div class="row">

			 <div class="col-12 col-md-6 col-lg-6 statColumn">
			 <div class="statItem statItemRect"> 
				<h6>Країна</h6>
 
				
				<div class="stat-table">
				<div class="stat-table-head">
					<div class="right"><div>Перегляди</div><div>Унік.</div></div>
				</div>
				<div class="stat-table-content scrollable-container">
				
				
				<div class="stat-table-row" *ngFor="let item of stat.contries">

				<div class="left">{{item.country}}</div>

				<div class="right"><div>{{item.vis}} </div><div>{{item.uniq}} </div></div>
 
				</div>
			 

				</div>


				</div>
	

			</div>

			</div>
		

			 <div class="col-12  col-md-6  col-lg-6 statColumn">
			 <div class="statItem statItemRect"> 

				<h6>Місто</h6>

				<div class="stat-table">
				<div class="stat-table-head">
					<div class="right"><div>Перегляди</div><div>Унік.</div></div>
				</div>
					<div class="stat-table-content  scrollable-container">
				
					<div class="stat-table-row" *ngFor="let item of stat.cities">

					<div class="left">{{item.city}}</div>

					<div class="right"><div>{{item.vis}} </div><div>{{item.uniq}} </div></div>
	 

					</div>
				</div>

				</div>

			</div>

			</div>
		</div>

 
	</div>

</div>
</div>
</div>

<ng-template #load>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>
</ng-template> 

